import React from 'react';
import { makeBtStyles } from '../Theme';

import { StyleDef } from '../utils';
import { ThemeConfig } from '../themes';
import SocialMediaLink from '../components/SocialMediaLink';
import { useBrandingData, useFeatureEnables } from '../dataProviders';

export interface SocialMediaGridStyles {
  root?: StyleDef,
  link?: StyleDef,
  linkIcon?: StyleDef
}
export interface SocialMediaGridClasses {
  root?: string,
  link?: string,
  linkIcon?: string
}

export default function SocialMediaGrid({ classes={} }: {
  classes: SocialMediaGridClasses
}) {
  const { showSocialMedia } = useFeatureEnables();
  const { social_media } = useBrandingData();
  const validLinks = social_media.filter( ({ url }) => url );

  if( !showSocialMedia ) {
    return null;
  }

  return (
    <div className={classes.root}>
      { validLinks.map( link => (
        <SocialMediaLink
          key={link.type}
          link={link}
          classes={{ root: classes.link, icon: classes.linkIcon }}
        />
      ))}
    </div>
  );
}

export function makeSocialMediaGridStyles(styles: (theme:ThemeConfig) => SocialMediaGridStyles) {
  return makeBtStyles( theme => {
    const styleOverrides = styles(theme);
    return {
      ...styleOverrides, // for any toplevel class/styles that we don't need defaults for
      root: {
        display: 'flex',
        ...styleOverrides.root
      },
      link: {
        '&:last-child': {
          paddingRight: '0'
        },
        ...styleOverrides.link
      },
      linkIcon: {
        verticalAlign: 'middle',
        ...styleOverrides.linkIcon
      }
    };
  }, { name: 'SocialStyles' } );
}


